import { ManageSavedViewsDrawer } from './ManageSavedViewsDrawer';
import { SaveViewDrawer } from './SaveViewDrawer';
import { ActiveViewApplier, ReportingTableViewSync } from './useSavedViews';

export const ReportingSavedViewsTableSync = ({ tab, savedViewsState }) => {
  const {
    savedViews = [],
    savedViewsReady,
    defaultView,
    activeViewId,
    setActiveViewId,
    saveViewModal,
    setSaveViewModal,
    manageViewsOpen,
    setManageViewsOpen,
    handleSave,
    handleDelete,
    handleEditView,
    handleSetDefault,
    defaultViewApplyOnceRef,
    setPendingApply,
    pendingApply,
    setBannerViewQuerySynced,
  } = savedViewsState;

  return (
    <>
      <SaveViewDrawer
        open={saveViewModal}
        onClose={() => setSaveViewModal(false)}
        onSave={handleSave}
      />
      <ReportingTableViewSync
        savedViewsReady={savedViewsReady}
        activeViewId={activeViewId}
        setActiveViewId={setActiveViewId}
        savedViews={savedViews}
        defaultView={defaultView}
        defaultAppliedRef={defaultViewApplyOnceRef}
        setBannerViewQuerySynced={setBannerViewQuerySynced}
        pendingApply={pendingApply}
      />
      <ActiveViewApplier
        pendingApply={pendingApply}
        setPendingApply={setPendingApply}
        setBannerViewQuerySynced={setBannerViewQuerySynced}
      />
      <ManageSavedViewsDrawer
        open={manageViewsOpen}
        onClose={() => setManageViewsOpen(false)}
        savedViews={savedViews}
        activeViewId={activeViewId}
        tab={tab}
        onLoad={(id, params) => {
          setActiveViewId(id);
          setPendingApply({ params, key: Date.now() });
          setManageViewsOpen(false);
        }}
        onDelete={handleDelete}
        onEditView={handleEditView}
        onSetDefault={handleSetDefault}
      />
    </>
  );
};
